// extracted by mini-css-extract-plugin
export default {"corprate-desc-wrapper":"corprate-desc-wrapper_cy1WE"};